import { CSSProperties } from 'react';

import { ResponsiveImage } from '@natu/ui/ResponsiveImage';
import { cn } from '@natu/utils/cn';

import {
  getAssetFromStoryblok,
  resolveStoryblokStyles,
  sbEditable,
  type SBProps,
  type Spacing,
  type StoryblokAsset,
  type StoryblokPalette,
} from '../../../utils';

interface SBBackgroundCardProps {
  bgColor?: StoryblokPalette;
  mtMobile?: Spacing;
  mtTablet?: Spacing;
  mtDesktop?: Spacing;
  mbMobile?: Spacing;
  mbTablet?: Spacing;
  mbDesktop?: Spacing;
  cardTitle?: string;
  content?: string;
  asset?: StoryblokAsset;
}

export const SBBackgroundCard = ({ blok }: SBProps<SBBackgroundCardProps>) => {
  const {
    bgColor,
    mbDesktop,
    mbMobile,
    mbTablet,
    mtDesktop,
    mtMobile,
    mtTablet,
    content,
    asset,
    cardTitle,
  } = blok;

  const className = resolveStoryblokStyles({
    mt: mtMobile,
    mtTablet,
    mtDesktop,
    mb: mbMobile,
    mbTablet,
    mbDesktop,
    className: bgColor?.value ? 'bg-[var(--bg-sb-color)]' : undefined,
  });

  const image = getAssetFromStoryblok(asset, { type: 'image' });
  const { alt, src, title, height, width } = image;

  const style = bgColor?.value ? ({ '--bg-sb-color': bgColor?.value } as CSSProperties) : undefined;

  return (
    <div style={style} className={cn(className, 'h-fit rounded-xl p-8')} {...sbEditable(blok)}>
      {src ? (
        <ResponsiveImage
          src={src || ''}
          alt={alt || ''}
          width={width}
          height={height}
          title={title || ''}
          className="mb-8"
        />
      ) : null}
      <h3 className="mb-2 text-xl font-semibold text-gray-900">{cardTitle}</h3>
      <p className="text-gray-600">{content}</p>
    </div>
  );
};
